module.exports = __webpack_public_path__ + "media/images/bul-faq-fde25086.gif";